import fetcher from '../fetcher'

import type { CareerPath } from './types'
import config from '../../config'
import { IResponseBody } from '../types'

/**
 * Returns all career paths.
 * @returns Array<CareerPath>
 */
export const getAllCareerPaths = async (): Promise<Array<CareerPath> | undefined> => {
  try {
    const res: IResponseBody<Array<CareerPath>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/career-paths`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching career paths: ${error}`)
    throw error
  }
}
